import { Components, Theme } from "@mui/material";

export const MuiFormLabel: Components<Theme>["MuiFormLabel"] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        ...theme.typography.formLabel,
        "& .MuiFormLabel-asterisk": {
          color: theme.palette.warning.main,
        },
      };
    },
  },
};
